module.exports = __webpack_public_path__ + "media/images/icons/icon_document-6b88c4e7381011c8bd6c699c3e2775b1.svg";